import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface PaginationButtonProps {
    active: boolean;
    children: number;
}

export const PaginationButton = styled.button.attrs({ type: 'button' })<PaginationButtonProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: ${theme.sizes[32]};
    width: ${(props) => {
        const page = props.children;
        if (page < 100) {
            return '32px';
        }
        return '44px';
    }};
    color: ${(props) => (props.active ? theme.colors.foreground.onEmphasis : theme.colors.foreground.default)};
    background-color: ${(props) => (props.active ? theme.colors.accent.emphasis : 'transparent')};
    border-radius: ${theme.radii[4]};
    margin-left: ${theme.space[2]};
    margin-right: ${theme.space[2]};
    border: none;
    font-size: 16px;

    &:hover {
        background-color: ${(props) => !props.active && theme.colors.background.subtle};
        border-width: ${(props) => !props.active && '1px'};
        border-color: ${(props) => !props.active && theme.colors.border.muted};
        border-style: ${(props) => !props.active && 'solid'};
    }

    &:disabled {
        cursor: not-allowed;
    }
`;
